var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"onbeforeunload":_vm.checkLeave}},[_c('a',{staticStyle:{"position":"absolute","z-index":"-1","font-size":"12px"},attrs:{"id":"text-size"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }